/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useState, useRef } from 'react';
import { Phone, Mail, MapPin, Clock, Send, CheckCircle } from 'lucide-react';
import emailjs from '@emailjs/browser';
import '../styles/Contatos.css';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    email: '',
    telefone: '',
    servico: '',
    mensagem: '',
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const formRef = useRef();

  const contactInfo = [
    {
      icon: Phone,
      title: 'Telefone',
      details: [
        { text: '+258 84 704 1103', link: 'tel:+258847041103' },
        { text: '+258 87 704 1104', link: 'tel:+258877041104' },
      ],
      description: 'Ligue-nos para assistência imediata',
    },
    {
      icon: Mail,
      title: 'Email',
      details: [
        { text: 'adm@firesafety.co.mz', link: 'mailto:adm@firesafety.co.mz' },
        
      ],
      description: 'Envie-nos um email a qualquer momento',
    },
    {
      icon: MapPin,
      title: 'Localização',
      details: [
        {text:'AV.Oloaf Palme nº245, 1º andar, Maputo - Moçambique', link:'https://maps.app.goo.gl/8QrBbBmDfkMPXSxA7'},
        { text:'AV.Moçambique, km9, Bairro do Zimpeto, Maputo - Moçambique', link:'https://maps.app.goo.gl/BPUrm9JmMPajXSef7' }
      ],
      description: 'Visite o nosso escritório principal',
    },
    {
      icon: Clock,
      title: 'Horário',
      details: ['Segunda - Sexta: 8h - 17h', 'Sábado: 8h - 14h'],
      description: 'Estamos disponíveis para atendê-lo durante o horário comercial',
    },
  ];

  const services = [
    'Compra de Produtos',
    'Cursos',
    'Treinamento Especializado',
    'Manutenção e Inspeção',
    'Consultoria em Segurança',
    'Outros Serviços',
  ];

  const validateForm = () => {
    if (!formData.nome.trim()) return 'Nome é obrigatório';
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) return 'Email inválido';
    if (!formData.telefone.trim()) return 'Telefone é obrigatório';
    if (!formData.servico) return 'Selecione um serviço';
    if (!formData.mensagem.trim()) return 'Mensagem é obrigatória';
    return '';
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsLoading(true);
    emailjs
      .sendForm(
        'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
        formRef.current,
        'YOUR_PUBLIC_KEY' // Replace with your EmailJS public key
      )
      .then(
        () => {
          setIsSubmitted(true);
          setIsLoading(false);
          setTimeout(() => {
            setIsSubmitted(false);
            setFormData({
              nome: '',
              empresa: '',
              email: '',
              telefone: '',
              servico: '',
              mensagem: '',
            });
          }, 3000);
        },
        (error) => {
          setError('Falha ao enviar a mensagem. Tente novamente.');
          setIsLoading(false);
          console.error('EmailJS error:', error);
        }
      );
  };

  return (
    <div className="contacto-page">
      <section className="page-hero" aria-label="Cabeçalho contactos">
        <div className="container">
          <span className="section-subtitle">Entre em Contacto</span>
          <h1 className="section-title">Estamos Aqui Para Ajudar</h1>
          <p className="section-description">Entre em contacto para soluções personalizadas em segurança contra incêndios. Equipa especializada pronta para atender com profissionalismo.</p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-grid">
            {contactInfo.map((info, index) => {
              const IconComponent = info.icon;
              return (
                <div key={index} className="contact-card" style={{ animationDelay: `${index * 0.2}s` }}>
                  <div className="contact-icon-page">
                    <IconComponent size={32} />
                  </div>
                  <h3>{info.title}</h3>
                  {info.details.map((detail, i) => (
                    <p className='detalhes' key={i}>
                      {typeof detail === 'string' ? (
                        detail
                      ) : (
                        <a href={detail.link} className="contact-link">
                          {detail.text}
                        </a>
                      )}
                    </p>
                  ))}
                  <p className="contact-description">{info.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-card">
              <div className="section-header">
                <span className="section-subtitle">Solicite Orçamento</span>
                <h2>Fale Connosco</h2>
                <p>Preencha o formulário e entraremos em contacto em breve</p>
              </div>

              {isSubmitted ? (
                <div className="success-message" role="alert" aria-live="polite">
                  <CheckCircle size={48} />
                  <h3>Mensagem Enviada!</h3>
                  <p>Obrigado pelo seu contacto. Responderemos em breve.</p>
                </div>
              ) : (
                <form ref={formRef} onSubmit={handleSubmit} role="form" aria-label="Formulário de contacto">
                  {error && (
                    <div className="error-message" role="alert" aria-live="assertive">
                      {error}
                    </div>
                  )}
                  <div className="form-grid">
                    <div className="field">
                      <label htmlFor="nome">Nome Completo *</label>
                      <input id="nome" type="text" name="nome" placeholder="Seu nome" value={formData.nome} onChange={handleInputChange} required autoComplete="name" />
                    </div>
                    <div className="field">
                      <label htmlFor="empresa">Empresa</label>
                      <input id="empresa" type="text" name="empresa" placeholder="Nome da empresa" value={formData.empresa} onChange={handleInputChange} autoComplete="organization" />
                    </div>
                    <div className="field">
                      <label htmlFor="email">Email *</label>
                      <input id="email" type="email" name="email" placeholder="seu@email.com" value={formData.email} onChange={handleInputChange} required autoComplete="email" />
                    </div>
                    <div className="field">
                      <label htmlFor="telefone">Telefone *</label>
                      <input id="telefone" type="tel" name="telefone" placeholder="+258 ..." value={formData.telefone} onChange={handleInputChange} required autoComplete="tel" />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="servico">Serviço *</label>
                    <select id="servico" name="servico" value={formData.servico} onChange={handleInputChange} required>
                      <option value="">Selecione um Serviço</option>
                      {services.map((service, index) => (
                        <option key={index} value={service}>{service}</option>
                      ))}
                    </select>
                  </div>
                  <div className="field">
                    <label htmlFor="mensagem">Mensagem *</label>
                    <textarea id="mensagem" name="mensagem" placeholder="Descreva suas necessidades..." value={formData.mensagem} onChange={handleInputChange} rows="5" required />
                  </div>
                  <button
                    type="submit"
                    className="btn-primary"
                    disabled={isLoading || isSubmitted}
                    aria-label="Enviar mensagem"
                  >
                    <Send size={20} />
                    {isLoading ? 'Enviando...' : 'Enviar Mensagem'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default Contacto;